<div class="container">
  <div class="row">
    <div class="col-md-4">
      <img src="./assets/images5/about.png" height="350px" alt="">
    </div>
    <div class="col-md-8" style="padding: 50px;text-align: center" >
      <h6 >Projet 1 :Web Application for HR Management inside our Faculty .</h6>
      <br>
      <hr>

      <ul>
        <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
        <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
        <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
        <li>Tache 1 : Lorem Lorem Lorem Lorem Lorem </li>
      </ul>

    </div>
  </div>
</div>
